import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inactive-notification-dialog',
  templateUrl: './inactive-notification-dialog.component.html',
  styleUrls: ['./inactive-notification-dialog.component.scss'],
  standalone: false,
})
export class InactiveNotificationDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
